import React from 'react'
import { Table } from 'react-bootstrap'

const ErrorsTable = ({ errors = [] }) => {
  return (
    <Table>
      <thead>
        <tr>
          <th />
          <th>Proceso</th>
          <th>Valor Actualizado</th>
        </tr>
      </thead>
      <tbody>
        {errors.map(error => (
          <tr key={error.field}>
            <td>{error.field}</td>
            <td>{error.value}</td>
            <td>{error.new_value}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  )
}

export default ErrorsTable;
